const win = window;
{
  win.o_global ||= {};
  win.o_util ||= {};
}
const { o_global, o_util } = win;
export {
  o_global,
  o_util,
  win
};
/*                                                          */
